import axios from 'axios';
import {AuthModel, UserModel, BranchModel} from './_models';

const API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const REACT_APP_VERSION_START = process.env.REACT_APP_VERSION_START;
console.log(REACT_APP_VERSION_START)
// Server should return AuthModel
const regexUrl = /^(([0-9]{1,3}\.){3}[0-9]{1,3})(:[0-9]{1,5})?/;

function hasIP(url: string): boolean {
  return regexUrl.test(url);
}
var hostname = window.location.hostname;
const referer = window.document.referrer;
if (referer) {
  const regex = /^https?:\/\//i;
  const hostname = referer.replace(regex, '');
  
  console.log(hostname);
}
var tenant = '';
// 
if (hostname?.includes('localhost') || hasIP(hostname) || hostname?.includes('demoxp'))  {
  tenant = 'root';

} else {
  var arr = hostname.split('.');
  tenant = arr[0];
}

export const GET_USER_BY_ACCESSTOKEN_URL = REACT_APP_VERSION_START == 'dev' ?  `${API_URL}/api/personal/profile` :`/api/personal/profile`;
export const GET_LIST_BRANCH = REACT_APP_VERSION_START == 'dev' ? `${API_URL}/api/v1/branchusers/search` : `/api/v1/branchusers/search`;
export const GET_PERMISSIONS_BY_URL = REACT_APP_VERSION_START == 'dev' ? `${API_URL}/api/personal/permissions` : `/api/personal/permissions`;
export const LOGIN_URL = REACT_APP_VERSION_START == 'dev' ? `${API_URL}/api/tokens` : `/api/tokens`;
export const REGISTER_URL =REACT_APP_VERSION_START == 'dev' ?  `${API_URL}/api/tenants` : `/api/tenants`;
export const REQUEST_PASSWORD_URL =REACT_APP_VERSION_START == 'dev' ?  `${API_URL}/api/users/forgot-password` :`/api/users/forgot-password`;
export const RESET_PASSWORD_URL = REACT_APP_VERSION_START == 'dev' ? `${API_URL}/api/users/reset-password` :`/api/users/reset-password`;
console.log(GET_USER_BY_ACCESSTOKEN_URL)
export function login(userName: string, password: string) {
  return axios.post<AuthModel>(
    // `http://${tenant}${REACT_APP_DOMAIN}/api/tokens`
    LOGIN_URL,
    {
      userName,
      password,
    },
    {headers: {tenant: tenant, 'Content-Type': 'application/json', Accept: 'application/json'}}
  );
}

// Server should return AuthModel
export function register(
  id: string,
  name: string,
  adminEmail: string,
  userName: string,
  password: string,
  phoneNumber: string
) {
  return axios
    .post(REGISTER_URL, {
      adminEmail,
      name,
      id,
      userName,
      password,
      phoneNumber,
      address: '',
      connectionString: '',
      issuer: '',
    })
    .catch((error) => {
      return error?.response ?? null;
    });
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  var myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('tenant', tenant);
  var raw = JSON.stringify({"email":email});
 return  fetch(
  //`http://${tenant}${REACT_APP_DOMAIN}/api/users/forgot-password` 
  REQUEST_PASSWORD_URL, {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  })
  .then((response) => response.status)
  .catch((res) => console.log(res ))
}
export function resetPassword(code: string,newPassword: string,email: string) {
  var myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('tenant', tenant);
  var raw = JSON.stringify({"token":code,"password":newPassword,"email":email});
 return  fetch(  RESET_PASSWORD_URL  
  //`http://${tenant}${REACT_APP_DOMAIN}/api/users/reset-password`
 , {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  })
  .then((response) => response)
  .catch((res) =>  console.log(res ))
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(
    GET_USER_BY_ACCESSTOKEN_URL
    //`http://${tenant}${REACT_APP_DOMAIN}/api/personal/profile`
    );
}

export function getBranchByToken(token: string | undefined) {
  return axios.post<Array<BranchModel>>(
    GET_LIST_BRANCH
    //`http://${tenant}${REACT_APP_DOMAIN}/api/v1/branchusers/search`
    ,
    {
    },
    {
      headers: {
        tenant: tenant,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export function getPermissonByName(userName: string | undefined, token : string | undefined) {
  return axios.get<Array<BranchModel>>(
    //`http://${tenant}${REACT_APP_DOMAIN}/api/users/${userName}/permissions`
    GET_PERMISSIONS_BY_URL,
    {
      headers: {
        tenant: tenant,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

